import queryBinding from './queryBinding'
export default queryBinding